import { fromJS, List, Map, isImmutable } from 'immutable'
import _ from 'lodash'

import { safeSetIn } from '../../../lib/immutable-tools'
import { doProcessRules } from '../../../lib/processPortalRules'
import { IS_SERVER } from '../../../constants/ssr'

export const setElementValueBatch = (state, action) => {
  let resultState = state

  const paramsList = action.payload
  const currentPageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get('uid')

  paramsList.forEach((params) => {
    resultState = processElement(resultState, currentPageUID, params)
  })

  return resultState
}

const processElement = (state, currentPageUID, params) => {
  const [uid, value, type, path, doNotProcessCondition, propName, isIgnoreHidden] = params

  let allowAction = true

  if (_.size(uid) === 1) {
    const elemUid = _.first(uid)
    const elem = getElem(state, elemUid)

    if (
      elem.size > 0 &&
      checkRules(state, uid, elemUid, currentPageUID, state.hasIn(['project', 'Settings', 'elements', elemUid]))
    ) {
      allowAction = false
    }
  } else {
    const [repeatUID, elemUid] = uid
    const elem = getElem(state, elemUid)

    const hasElements = elem.size > 0
    const includesRepeatUID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).includes(repeatUID)
    const hasElementInSettings = state.hasIn(['project', 'Settings', 'elements', elemUid])
    const rulesCheck = checkRules(state, uid, elemUid, currentPageUID, hasElementInSettings)

    if (hasElements && includesRepeatUID && rulesCheck) {
      allowAction = false
    }
  }

  if (allowAction || isIgnoreHidden) {
    let retState = state

    switch (type) {
      case 'ClearBulkPowerTable': {
        retState = retState.setIn(['formFieldStatuses', path[0], String(path[1]).replace('bulk-', '')], Map())
        retState = updateState(retState, path, value)

        break
      }

      case 'PowerTable': {
        let val = retState.getIn(['state', ...path])

        if (val === undefined) {
          retState = updateState(retState, path, List().set(propName, value))
        } else if (propName === 0 && !isImmutable(val)) {
          retState = updateState(retState, path, List.of(value))
        } else {
          retState = updateState(retState, path, value, propName)
        }

        break
      }

      case 'Lookup':
      case 'PickList': {
        retState = updateState(retState, [...path, ...uid], value, propName)
        break
      }

      case 'Button': {
        retState = retState.setIn(['state', ...path, ...uid, 'BTN_TEXT'], value)
        break
      }

      case 'Image': {
        retState = retState.setIn(['state', ...path, ...uid, 'IMG_SRC'], value)
        break
      }

      case 'Typography': {
        retState = retState.setIn(['state', ...path, ...uid, 'TYPO_TEXT'], value)
        break
      }

      default: {
        try {
          retState = updateState(retState, [...path, ...uid], value)
        } catch (error) {
          let appState = retState.get('state', Map()).toJS()
          _.set(appState, [...path, ...uid], value)
          retState = retState.setIn(['state'], fromJS(appState))
        }
      }
    }

    if (!doNotProcessCondition && !IS_SERVER) {
      retState = doProcessRules(
        retState,
        Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
        [],
        [],
        [[...path, ...uid]]
      )
    }

    return retState
  }

  return state
}

const getElem = (state, elemUid) => {
  return state.hasIn(['project', 'Settings', 'elements', elemUid])
    ? state.getIn(['project', 'Settings', 'elements', elemUid], Map())
    : state.getIn(['pages', state.get('page'), 'Props', 'elements', elemUid], Map())
}

const checkRules = (state, uid, elemUid, currentPageUID, isProjectElem) => {
  const rules = state.getIn(['rules', isProjectElem ? elemUid : currentPageUID, uid], List())

  return List.isList(rules) && (rules.includes('readOnly') || rules.includes('hide'))
}

const updateState = (retState, path, value, propName = null) => {
  if (propName !== null) {
    return safeSetIn(retState, ['state', ...path, propName], value)
  }

  return safeSetIn(retState, ['state', ...path], value)
}
